import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () => import('@modules/modules.module')
      .then(m => m.ModulesModule),
  },
  {
    path: 'login',
    loadChildren: () => import('@modules/login/login.module')
      .then(m => m.LoginModule),
  },
  {
    path: '403',
    loadChildren: () => import('@modules/forbidden/forbidden.module')
      .then(m => m.ForbiddenModule),
  },
  {
    path: '404',
    loadChildren: () => import('@modules/not-found/not-found.module')
      .then(m => m.NotFoundModule),
  },
  {
    path: '**',
    loadChildren: () => import('@modules/not-found/not-found.module')
      .then(m => m.NotFoundModule),
  },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
